// src/pages/EditarProducto.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../Config';

const EditarProducto = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [categoriaId, setCategoriaId] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [stockMinimo, setStockMinimo] = useState(0);
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    // Obtener datos del producto
    axios.get(`${API_BASE_URL}/api/productos/${id}`)
      .then(res => {
        const { nombre, precio, categoria } = res.data;
        setNombre(nombre);
        setPrecio(precio);
        setCategoriaId(categoria?.id || '');
            setStockMinimo(stockMinimo || 0); // ✅ Agregar esto
      })
      .catch(err => {
        console.error(err);
        setMensaje('❌ Error al cargar el producto');
      });

    // Obtener todas las categorías
    axios.get(`${API_BASE_URL}/api/categorias`)
      .then(res => setCategorias(res.data))
      .catch(err => console.error('Error al cargar categorías', err));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/api/productos/${id}`, {
        nombre,
        precio,
        categoriaId,
        stockMinimo
      });
      setMensaje('✅ Producto actualizado correctamente');
      setTimeout(() => navigate('/admin-productos'), 2000);
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al actualizar el producto');
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Editar Producto</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block">Nombre</label>
            <input
              type="text"
              className="w-full border p-2 rounded"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block">Precio</label>
            <input
              type="number"
              className="w-full border p-2 rounded"
              value={precio}
              onChange={(e) => setPrecio(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mt-4">Stock mínimo</label>
<input
  type="number"
  className="w-full px-3 py-2 border rounded-md"
  value={stockMinimo}
  onChange={(e) => setStockMinimo(parseInt(e.target.value))}
/>

            <label className="block">Categoría</label>
            <select
              className="w-full border p-2 rounded"
              value={categoriaId}
              onChange={(e) => setCategoriaId(e.target.value)}
              required
            >
              <option value="">Seleccione una categoría</option>
              {categorias.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.nombre}</option>
              ))}
            </select>
          </div>
          <div className="flex justify-between items-center mt-4">
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Guardar Cambios
            </button>
            <button
              type="button"
              onClick={() => navigate('/admin-productos')}
              className="text-gray-600 hover:text-black underline"
            >
              Cancelar
            </button>
          </div>
        </form>
        {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
      </div>
    </div>
  );
};

export default EditarProducto;
